import { render, staticRenderFns } from "./Sfck.vue?vue&type=template&id=3a3f2332&scoped=true"
import script from "./Sfck.vue?vue&type=script&lang=js"
export * from "./Sfck.vue?vue&type=script&lang=js"
import style0 from "./Sfck.vue?vue&type=style&index=0&id=3a3f2332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f2332",
  null
  
)

export default component.exports